import { createSlice } from "@reduxjs/toolkit";
import { addBookingAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const addBookingSlice = createSlice({
  name: "addBooking",
  initialState: data,
  reducers: {
   addBookingSlice(state) {
      state.isLoading = true;
    },
   addBookingSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    addBookingSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   addBookingSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const addBookingHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(addBookingAction.addBookingSlice());
    const response: any = await addBookingAPI(data);
    
    dispatch(addBookingAction.addBookingSliceSuccess(response));
  } catch (e: any) {
    dispatch(addBookingAction.addBookingSliceFailure(e?.response?.data));
  }
};
export default addBookingSlice.reducer;
export const addBookingAction = addBookingSlice.actions;
